// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__168wN","outlined":"Button_outlined__1C4pg"};